import { isoSecondsFmt } from './date'
import { getWindow } from './global'
import Time from './time'

export type ClockListener = (timeNow: string) => void

// Ticks every second, on the second
// Provides ISO 8601 time, eg "2000-01-01T00:00:00Z"
class Clock {
  private timeNow = isoSecondsFmt(Time.now())

  private listeners = [] as ClockListener[]

  constructor() {
    getWindow()!.setInterval(() => {
      const newTimeNow = isoSecondsFmt(Time.now())
      if (newTimeNow <= this.timeNow) {
        return
      }
      this.timeNow = newTimeNow
      this.listeners.forEach(f => f(newTimeNow))
    }, 100)
  }

  addListener(listener: ClockListener) {
    this.listeners.push(listener)
  }

  removeListener(listener: ClockListener) {
    const ix = this.listeners.indexOf(listener)
    if (ix < 0) {
      throw new Error("Tried to remove a listener that doesn't exist")
    }
    this.listeners.splice(ix, 1)
  }

  now(): string {
    return this.timeNow
  }
}

export const clock = new Clock()
